import { useTranslation } from "react-i18next";
import { Form, Input, Select, Modal } from "@renderbus/ui";
import { useGlobalStore } from "@/store/GlobalStore";
import { FormInstance, ModalProps } from "antd";
import { useTabStore } from "../store/tab-store";
import styled from "styled-components";
import { ValidatorRule } from "rc-field-form/lib/interface";

const CouponTransferLabel = styled.div`
  flex: 1;
  span {
    float: right;
  }
`;

const CouponForm = styled(Form)`
  .ant-form-item-label > label {
    width: 100%;
  }
  .transfer-select .ant-select-selector {
    background-color: #2c2c31 !important;
  }
`;

export function TransferModal({
  open,
  modalProps,
  form,
}: {
  open: boolean;
  modalProps: ModalProps;
  form?: FormInstance;
}) {
  const { t } = useTranslation("coupon");
  const { isSubAccount, currencySymbol } = useGlobalStore();
  const { subAccountInfo, defaultSubAccount, currentAmount, isMainUser } =
    useTabStore();
  const m0 = t("coupon_shiftout_label_empty");

  const validateTransferAmount: ValidatorRule["validator"] = (_, value) => {
    if (+currentAmount.split(currencySymbol)[1] < +value) {
      return Promise.reject(t("coupon_shiftout_label_shortage"));
    }
    return Promise.resolve();
  };

  const handleInput = (event: any) => {
    const { value } = event.target;
    const newValue = value.replace(/[^\d.]/g, ""); // 只保留数字和小数点
    const match = newValue.match(/(^[0-9]{0,})(\.\d{0,3})?/); // 匹配最多三位小数的数字
    const finalValue = match[0]; // 取得匹配到的值
    event.target.value = finalValue;
  };

  return (
    <Modal
      open={open}
      title={
        isSubAccount || !isMainUser
          ? t("coupon_pages_get_way_transfer_to_main_account")
          : t("coupon_pages_get_way_transfer")
      }
      children={
        <CouponForm
          size={"large"}
          colon={false}
          form={form}
          labelAlign="left"
          layout={"vertical"}
          requiredMark={false}
          className={"renderbus-ui--form"}
        >
          <Form.Item
            key="destUserId"
            name="destUserId"
            label={t(
              isSubAccount || !isMainUser
                ? "coupon_pages_transfer_to_user"
                : "coupon_pages_transfer_to_subuser"
            )}
          >
            {!isSubAccount && isMainUser && (
              <Select
                allowClear={false}
                className="transfer-select"
                options={subAccountInfo}
                defaultValue={defaultSubAccount}
              />
            )}
          </Form.Item>
          <Form.Item
            key="amount"
            name="amount"
            validateTrigger="onChange"
            label={
              <CouponTransferLabel>
                {t("coupon_shiftout_label_fund")}
                <span>
                  {t("coupon_transfer_modal_text", { amount: currentAmount })}
                </span>
              </CouponTransferLabel>
            }
            rules={[
              {
                required: true,
                message: m0,
              },
              {
                validator: validateTransferAmount,
                validateTrigger: "onChange",
              },
            ]}
          >
            <Input className="background-2C2C31" onInput={handleInput} />
          </Form.Item>
        </CouponForm>
      }
      okText={t("coupon_modal_confirm_text")}
      cancelText={t("coupon_modal_cancel_text")}
      {...modalProps}
    />
  );
}
